import { BarChart3 } from 'lucide-react';
import type { SlotComponentProps } from '../../types';

const CommercialComparisonBlock = (_props: SlotComponentProps) => {
  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
      <div className="mb-4 flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-amber-100 text-amber-700">
          <BarChart3 className="h-5 w-5" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-slate-900">Commercial comparison layer</h2>
          <p className="text-sm text-slate-500">Value propositions and trade-offs appear when the user is considering options.</p>
        </div>
      </div>

      <div className="grid gap-3 md:grid-cols-3">
        {['Time to value', 'Coverage depth', 'Trust signal'].map((metric) => (
          <div key={metric} className="rounded-2xl bg-slate-50 p-4">
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{metric}</p>
            <p className="mt-2 text-lg font-semibold text-slate-900">Adaptive</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommercialComparisonBlock;